import { useCallback, useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useUserInfoStore } from '~/stores/userInfo';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

const useHeader = () => {
  const { canGoBack, goBack } = useNavigation();

  const user = useUserInfoStore((state) => state.user);

  const isLoggedIn = useMemo(() => !!user, [user]);

  const canBack = useMemo(() => {
    return canGoBack();
  }, [canGoBack]);

  const onGoBack = useCallback(
    (onBack?: () => void) => {
      if (onBack) {
        onBack();
        return;
      }

      if (canBack) {
        goBack();
      }
    },
    [canBack, goBack]
  );

  const onPressLogin = () => {
    MarisaAppUtils.goToLogin();
  };

  return {
    isLoggedIn,
    onPressLogin,
    canBack,
    onGoBack,
  };
};

export default useHeader;
